import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import HomePage from './pages/HomePage';
import MintPage from './pages/MintPage';
import StakingPage from './pages/StakingPage';
import Navigation from './components/Navigation';
import { NavigationProvider } from './context/NavigationContext';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#000000',
      paper: '#1a1a1a',
    },
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#808080',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <NavigationProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mint" element={<MintPage />} />
            <Route path="/staking" element={<StakingPage />} />
          </Routes>
          <Navigation />
        </Router>
      </NavigationProvider>
    </ThemeProvider>
  );
}

export default App; 